import { createContext, PropsWithChildren } from 'react';
import { theme as wllTheme } from '@/core/App/theme';
import { ThemeProvider } from 'react-admin';
import { LocalStorageProvider } from '@/contexts/LocalStorage';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from '@/state/store';
import MessagingBusProvider from '@/contexts/MessagingBusContext';
import { ThemeProvider as WllThemeProvider } from '@wlloyalty/ui';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';

// Only initialise PostHog in production builds. In development and staging the
// client stays uninitialised — usePostHog() returns the same instance but all
// capture/identify calls are no-ops, so no test traffic pollutes the dataset.
if (import.meta.env.MODE === 'production') {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    defaults: '2026-01-30',
  });
}

const GlobalContext = createContext({});

export default function GlobalContextProvider({ children }: PropsWithChildren) {
  return (
    <GlobalContext.Provider value={{}}>
      <PostHogProvider client={posthog}>
        <WllThemeProvider>
          <ThemeProvider theme={wllTheme}>
            <LocalStorageProvider>
              <ReduxProvider store={store}>
                <MessagingBusProvider>{children}</MessagingBusProvider>
              </ReduxProvider>
            </LocalStorageProvider>
          </ThemeProvider>
        </WllThemeProvider>
      </PostHogProvider>
    </GlobalContext.Provider>
  );
}
